import React, { PureComponent, PropTypes } from 'react'
import styles from './styles'

export default class Button extends PureComponent {
  static propTypes = {
    onClick: PropTypes.func,
    children: PropTypes.any,
  }

  static defaultProps = {
    disabled: true,
  }

  get className() {
    return (this.props.disabled) ? styles.button : styles.active
  }

  render() {
    const { onClick, children } = this.props
    return (
      <button onClick={onClick} className={this.className}>
        {children}
      </button>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/BottomBar/Button/Button.js
 **/